// Seguimiento de afiliados: guarda el código `ref` del enlace en cookie durante 60 días,
// cuenta el clic y asegura un identificador de dispositivo estable (anti auto-indicación).
const KEY = "lura_ref";
const AT = "lura_ref_at";
const DID = "lura_did";
const WINDOW_MS = 60 * 86400000;

function setCookie(name, value, days) {
  try {
    const exp = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = `${name}=${encodeURIComponent(value)}; expires=${exp}; path=/; SameSite=Lax`;
  } catch (e) { /* noop */ }
}

function getCookie(name) {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
    return m ? decodeURIComponent(m[1]) : null;
  } catch { return null; }
}

export function ensureDeviceId() {
  let id = getCookie(DID);
  if (!id) {
    try { id = (crypto.randomUUID && crypto.randomUUID()) || String(Date.now()) + Math.random().toString(16).slice(2); }
    catch { id = String(Date.now()) + Math.random().toString(16).slice(2); }
    setCookie(DID, id, 365);
  }
  return id;
}

export function captureRefFromUrl() {
  ensureDeviceId();
  try {
    const ref = new URLSearchParams(window.location.search).get("ref");
    if (ref) {
      const v = ref.trim();
      // Cuenta el clic SIEMPRE (público, no revela si el código existe).
      try {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/api/affiliates/track`, {
          method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ code: v }),
        }).catch(() => {});
      } catch (e) { /* noop */ }
      // Gana el PRIMER ref válido: no se sobrescribe si ya hay uno guardado y vigente.
      if (!getStoredRef()) {
        localStorage.setItem(KEY, v);
        localStorage.setItem(AT, String(Date.now()));
        setCookie(KEY, v, 60);
      }
      return v;
    }
  } catch (e) { console.warn("No se pudo guardar el ref de afiliado:", e); }
  return null;
}

export function getStoredRef() {
  try {
    const ref = localStorage.getItem(KEY) || getCookie(KEY);
    if (!ref) return null;
    const at = Number(localStorage.getItem(AT) || 0);
    if (at && Date.now() - at > WINDOW_MS) {
      clearRef();
      return null;
    }
    return ref;
  } catch {
    return null;
  }
}

export function clearRef() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem(AT);
    setCookie(KEY, "", -1);
  } catch (e) { console.warn("No se pudo limpiar el ref de afiliado:", e); }
}
